import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as Common from '_common';
import { componentRegister } from '_componentRegister';
import { Code } from '_components';
export function Content(props) {
    const overrideCtx = React.useContext(ContentOverrideContext);
    if (!props.component) {
        return _jsx(_Fragment, {});
    }
    const type = props.component.type.toLowerCase();
    if (type === 'text') {
        if (props.component.properties.text) {
            return _jsx("span", { children: props.component.properties.text }, props.index);
        }
        return _jsx(_Fragment, {});
    }
    if (type === 'array') {
        return _jsx(_Fragment, { children: RenderChildren(props.component.children) });
    }
    let render = undefined;
    if (overrideCtx) {
        render = overrideCtx(type);
    }
    render = render || componentRegister(type);
    if (render) {
        return (_jsx(Common.ErrorBoundary, { errorGui: `Component ${type} cound not be rendered.`, children: typeof render === 'function' ? render(props.component, props.index) : render }));
    }
    if (Common.debugSettings.isDebug) {
        return _jsx(Code, { type: "json", source: JSON.stringify(props.component, null, 4) });
    }
    return _jsx(_Fragment, {});
}
export const RenderChildren = (components) => {
    if (!components) {
        return null;
    }
    return (_jsx(_Fragment, { children: components.map((cmp, index) => (_jsx(Content, { index: index, component: cmp }, index))) }));
};
export const ContentOverrideContext = React.createContext(null);
